import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const EventsIcon = props => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            d="M10.992,3A8,8,0,1,0,19,11,8,8,0,0,0,10.992,3ZM11,17.4A6.4,6.4,0,1,1,17.4,11,6.4,6.4,0,0,1,11,17.4ZM11.4,7H10.2v4.8l4.2,2.52.6-.984L11.4,11.2Z"
            transform="translate(-3 -3)"
        />
    </SvgIcon>
);

export default EventsIcon;
